import React from 'react'
import { Issue } from '@/Components/Issues/Issue';
import { format } from 'date-fns';
import { dateformat } from '@/utils/GlobalConstants';
import { AcknowledgedIcon, DashboardIcon, SeenIcon, StatusReportIcon } from '@/Components/ui/Icons/TooltipIcon';
import { getRatingColor, getStatusColor } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface IssuePopupProps {
  issue: Issue;
}

const IssuePopup: React.FC<IssuePopupProps> = ({ issue }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className='flex flex-col w-full text-2xl'>
        <div className='flex flex-row mb-4'><div className="w-48 font-semibold">Work Package:</div><div>{issue.workPackage}</div><div className='flex flex-row my-auto px-2'>{issue.displayOnStatusReport ? <StatusReportIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}{issue.displayOnDashboard ? <DashboardIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}</div></div>
        <div className='flex flex-col gap-4 mb-4'>
          <div className='flex flex-row'><div className="w-48 font-semibold">Raised By: </div> {issue.raisedBy ? issue.raisedBy : "N/A"} - {format(new Date(issue.date), dateformat)}</div>
          <div className='flex flex-row'><div className="w-48 font-semibold">Owner: </div><div>{issue.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{issue.seen ? <SeenIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}{issue.acknowledged ? <AcknowledgedIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}</div></div>
          <div className='flex flex-row'><div className="w-48 font-semibold">Rating: </div> <div className={'w-48 text-center ' + getRatingColor(issue.rating as "High" | "Medium" | "Low")}>{issue.rating}</div></div>
          <div className='flex flex-row'><div className="w-48 font-semibold">Status: </div> <div className={'w-48 text-center ' + getStatusColor(issue.status)}>{issue.status}</div></div>
        </div>
        <div className='mb-4'>
          <div className='font-semibold'>Issue:</div>
          <div>{issue.description}</div>
        </div>
        <div className='mb-4'>
          <div className='font-semibold'>Resolution:</div>
          <div>{issue.resolution}</div>
        </div>
        <div className='mb-4'>
          <div className='font-semibold'>Notes:</div>
          <div>{issue.notes && issue.notes}</div>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-row'><div>Work Package:</div><div className='px-2'>{issue.workPackage}</div><div className='flex flex-row my-auto px-2'>{issue.displayOnStatusReport ? <StatusReportIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}{issue.displayOnDashboard ? <DashboardIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}</div></div>
      <div className='flex flex-row my-4 justify-between'>
        <div className='flex flex-col gap-4 mr-8'>
          <div className='flex flex-row'><div className="w-24">Raised By: </div> {issue.raisedBy} - {format(new Date(issue.date), dateformat)}</div>
          <div className='flex flex-row'><div className="w-24">Owner: </div><div>{issue.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{issue.seen ? <SeenIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}{issue.acknowledged ? <AcknowledgedIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}</div></div>
          <div className='flex flex-row'><div className="w-24">Rating: </div> <div className={'w-24 text-center ' + getRatingColor(issue.rating as "High" | "Medium" | "Low")}>{issue.rating}</div></div>
          <div className='flex flex-row'><div className="w-24">Status: </div> <div className={'w-24 text-center ' + getStatusColor(issue.status)}>{issue.status}</div></div>
        </div>
      </div>
      <div>
        <div>Issue:</div>
        <div>{issue.description}</div>
      </div>
      <div>
        <div>Resolution:</div>
        <div>{issue.resolution}</div>
      </div>
        <div>
          <div>Notes:</div>
          <div>{issue.notes && issue.notes}</div>
        </div>
    </div>
  )
}

export default IssuePopup